import { CurrencyEuroIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import type { FunctionComponent } from "react";
import { useCallback } from "react";

import Tooltip from "~/components/Tooltip.tsx";

type Props = {
	filterValue: boolean[];
	onChange: (value: boolean[]) => void;
};

const BillabilityFilter: FunctionComponent<Props> = ({ filterValue, onChange }) => {
	const billableActive = filterValue.includes(true);
	const nonBillableActive = filterValue.includes(false);

	const toggleValue = useCallback((value: boolean, active: boolean) => {
		const newValue = filterValue.filter((entry) => entry !== value);
		if (!active) {
			newValue.push(value);
		}
		onChange(newValue);
	}, [filterValue, onChange]);

	return <div className="flex h-full flex-row items-center">
		<Tooltip text="Abrechenbare Erfassungen anzeigen">
			<button className={clsx("rounded-l-lg bg-success-500 p-2",
				billableActive ? "opacity-100" : "opacity-40",
			)}
					type="button"
					onClick={() => toggleValue(true, billableActive)}>
				<CurrencyEuroIcon className="size-4 fill-white" />
			</button>
		</Tooltip>
		<Tooltip text="Nicht abrechenbare Erfassungen anzeigen">
			<button className={clsx("rounded-r-lg bg-red-500 p-2",
				nonBillableActive ? "opacity-100" : "opacity-40",
			)}
					onClick={() => toggleValue(false, nonBillableActive)}>
				<CurrencyEuroIcon className="size-4 fill-white" />
			</button>
		</Tooltip>
	</div>;
};

export default BillabilityFilter;
